import { Icon } from '@acast/decibel';
import { BullhornSolidGlyph } from '@acast/decibel-glyphs';
import T from 'prop-types';
import React from 'react';
import { formatTimeWholeSeconds } from 'shared/helpers/time';
import { markerPropType } from '../../../../../../../customPropTypes';
import AnchorLine from './anchor-line';
import DragAndDropContainer from './drag-and-drop';

const MARKER_WIDTH = 84;
const createTestId = (id, placement) =>
  `TimelineMarker TimelineMarker--Ad TimelineMarker--${id} TimelineMarker--${placement}`;

const AdMarker = ({ selected, marker, markers, ...restProps }) => (
  <DragAndDropContainer marker={marker} markers={markers} markerWidth={MARKER_WIDTH} {...restProps}>
    {({ setRef, markerOffsetLeft, anchorLineOffsetLeft, onMouseDown }) => (
      <>
        <AnchorLine selected={selected} offsetLeft={anchorLineOffsetLeft} />
        <div
          ref={setRef}
          style={{
            width: MARKER_WIDTH,
            left: markerOffsetLeft,
          }}
          className={`marker marker--ad ${selected ? 'marker--selected' : ''}`}
          data-timestamp={formatTimeWholeSeconds(marker.start)}
          data-test-id={createTestId(marker.id, marker.body.placement)}
          onMouseDown={onMouseDown}
        >
          <Icon glyph={BullhornSolidGlyph} size="1em" />
        </div>
      </>
    )}
  </DragAndDropContainer>
);

AdMarker.propTypes = {
  marker: markerPropType.isRequired,
  markers: T.arrayOf(markerPropType).isRequired,
  selected: T.bool.isRequired,
};

export default AdMarker;
